export default {
  name: 'DrImage',
  functional: true,
  props: {
    imgStyle: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
    },
    alt: {
      type: String,
      default: '图片'
    }
  },
  render(h, context) {
    const { src, alt, imgStyle } = context.props
    let img = ''
    if (src) {
      img = require('@/assets/images/' + src)
    }
    return (
      <img style='width: 100%; height: 100%;' style={imgStyle} src={img} alt={alt} />
    )
  }
}
